<template>
    <div class="Dashboard">
        <div class="header">
            <div class="name">{{ $f.tc('botList') }}</div>
            <v-flex></v-flex>
            <input v-model="searchKey" type="text" :placeholder="this.$f.tc('search')">
            <v-flex></v-flex>
        </div>
        <div class="body">
            <div v-for="(botList, role) in data" :key="role">
                <div class="role">{{ $f.tc(role) }}</div>
                <div class="bot-list">
                    <div v-for="bot in botList" :key="bot.code" class="bot-item" @click="goToBot(bot)">
                        <div class="bot-item-header">
                            <div class="bot-image">
                                {{ $ut.getImageName(bot.name) }}
                            </div>
                            <div>
                                <div class="bot-name">{{ bot.name }}</div>
                                <div class="bot-lang">{{ MapCodeToLanguage[bot.language] }}</div>
                            </div>
                        </div>
                        <v-layout class="bot-item-row">
                            <v-flex xs6>{{ $f.tc('scenario') }}</v-flex>
                            <v-flex xs6>{{ bot.scenario }}</v-flex>
                        </v-layout>
                        <v-layout class="bot-item-row">
                            <v-flex xs6>{{ $f.tc('step') }}</v-flex>
                            <v-flex xs6>{{ bot.step }}</v-flex>
                        </v-layout>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

const BOT_ROLE = {
    OWNER: 'bot_owner',
    ADMIN: 'bot_admin',
    EDITOR: 'bot_data_editor',
    CUSTOM: 'custom_role'
}

const MapCodeToLanguage = {
    vi: 'Vietnamese',
    en: 'English',
    jp: 'Japanese'
}

export default {
    name: 'Dashboard',
    data () {
        return {
            MapCodeToLanguage,
            data: {},
            searchKey: ''
        }
    },
    computed: {
        ...mapState({
            botList: state => state.botList
        })
    },
    methods: {
        goToBot (bot) {
            this.searchKey = ''
            this.$router.push('/bots/' + bot.code)
        },
        refresh () {
            let data = {}
            let searchKey = this.searchKey.trim()
            this.botList.forEach(bot => {
                let botRole = bot.role_type === 'custom' ? 'custom_role' : bot.role
                if (!data[botRole]) {
                    data[botRole] = []
                }
                if (!searchKey || bot.name.toLowerCase().includes(searchKey)) {
                    data[botRole].push(bot)
                }
            })
            let dataSort = {}
            for (let i in BOT_ROLE) {
                let role = BOT_ROLE[i]
                if (data[role]) {
                    dataSort[role] = data[role]
                }
            }
            this.data = dataSort
        }
    },
    watch: {
        botList: {
            immediate: true,
            handler: function () {
                this.refresh()
            }
        },
        searchKey: 'refresh'
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/fci-var";

.header {
    height: 80px;
    display: flex;
    align-items: center;
    background: #fff;
    padding: 0 20px;

    .name {
        font-size: 24px;
        font-weight: bold;
    }

    input {
        border: 1px solid $borderColor3;
        height: 42px;
        min-width: 700px;
        border-radius: 5px;
        padding: 0 10px;

        &:focus {
            outline: none;
            border-color: $primary1;
        }
    }
}

.body {
    padding: 20px;

    .role {
        text-transform: uppercase;
        font-weight: bold;
        color: #888A9A;
    }
}

.bot-list {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0 30px 0;
}

.bot-item {
    margin: 0 20px 20px 0;
    background: $primary3;
    width: 350px;
    cursor: pointer;
    border-radius: 5px;

    &:hover {
        box-shadow: $shadow;
    }

    .bot-item-header {
        display: flex;
        padding: 10px;
    }

    .bot-image {
        width: 46px;
        height: 46px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $primary3;
        background: $primary1;
        margin-right: 10px;
    }

    .bot-name {
        font-weight: bold;
        font-size: 16px;
    }

    .bot-item-row {
        padding: 10px;
        border-top: 1px solid $borderColor3;
    }
}
</style>
